import type { RuleDefinition, RuleId } from '../domain/types';
import { BQ001 } from './bq001';
import { BQ002 } from './bq002';
import { BQ003 } from './bq003';
import { BQ004 } from './bq004';
import { BQ005 } from './bq005';
import { BQ006 } from './bq006';
import { BQ007 } from './bq007';
import { BQ008 } from './bq008';
import { BQ009 } from './bq009';
import { BQ010 } from './bq010';
import { BQ011 } from './bq011';
import { BQ012 } from './bq012';
import { BQ013 } from './bq013';
import { BQ014 } from './bq014';
import { BQ015 } from './bq015';
import { BQ016 } from './bq016';

export const RULES: readonly RuleDefinition[] = Object.freeze([
  BQ001,
  BQ002,
  BQ003,
  BQ004,
  BQ005,
  BQ006,
  BQ007,
  BQ008,
  BQ009,
  BQ010,
  BQ011,
  BQ012,
  BQ013,
  BQ014,
  BQ015,
  BQ016,
]);

export const RULE_REGISTRY: ReadonlyMap<RuleId, RuleDefinition> = new Map(
  RULES.map((rule) => [rule.id, rule]),
);

export function getRule(ruleId: RuleId): RuleDefinition {
  const rule = RULE_REGISTRY.get(ruleId);
  if (rule === undefined) throw new Error(`Unknown rule: ${ruleId}`);
  return rule;
}

export function validateRuleRegistry(rules: readonly RuleDefinition[] = RULES): readonly string[] {
  const errors: string[] = [];
  const seenIds = new Set<RuleId>();
  const seenNames = new Set<string>();
  rules.forEach((rule) => {
    if (seenIds.has(rule.id)) errors.push(`重复规则编号：${rule.id}`);
    if (seenNames.has(rule.name)) errors.push(`重复规则名称：${rule.name}`);
    if (rule.applicableFields.length === 0) errors.push(`${rule.id} 未声明适用字段`);
    if (rule.message.trim().length === 0) errors.push(`${rule.id} 未声明默认问题说明`);
    if (rule.suggestion.trim().length === 0) errors.push(`${rule.id} 未声明处理建议`);
    seenIds.add(rule.id);
    seenNames.add(rule.name);
  });
  return errors;
}
